import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'VOICE': {
      'ENABLE': 'Enable audio tracks to survey',
      'TITULO': 'Voice settings',
      'SUBTITULO': 'This setting will only be applied if the audio tracks to the survey are enabled.',
      'CONFIG_IDIOMA': {
        'TITULO': 'Current settings for this language',
        'GENERO': {
          'TITULO': 'Voice gender',
          'Femenino': 'Female',
          'Masculino': 'Male'
        },
        'TIPO_VOZ': {
          'TITULO': 'Type of voice',
          '1': 'Voice type 1',
          '2': 'Voice type 2',
          '3': 'Voice type 3',
          '4': 'Voice type 4',
          '5': 'Voice type 5',
          '6': 'Voice type 6',
          '7': 'Voice type 7',
          '8': 'Voice type 8',
          '9': 'Voice type 9',
          '10': 'Voice type 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': 'Voice test',
          'INSTRUCCION': 'Write a text to test the voice',
          'PLACEHOLDER': 'Voice test text',
          'PROBAR': 'Test text to speech'
        }
      },
      'MODALES': {
        'COMPLETAR': 'Are you sure you complete the step with the current voice selection?',
        'COMPLETAR_OFF': 'Are you sure you want to complete the step with voice settings disabled?',
        'INCOMPLETO': 'You have not yet made the full selection of voices in all languages, it is necessary to complete it to continue',
        'PASO_COMPLETO': 'Step completed successfully',
        'GENERANDO_AUDIOS': 'Voice settings are being applied to sections of this product, please wait a moment'
      }
    }
  }
};
